export default "__VITE_ASSET__C724VwVe__"